document.addEventListener("DOMContentLoaded", () => {
  function getPixelsOutsideViewportAdvan() {
    const element = document.querySelector("[data-advan-scroll-effect]");
    const seTrigger = document.querySelector("[data-advan-scroll-effect-trigger]");
    const seProgress = document.querySelector("[data-advan-progress]");

    if (!element && !seTrigger) {
      return;
    }

    const rect = seTrigger.getBoundingClientRect();
    let pixelsOutside = 0;

    // Sprawdzamy, czy górna krawędź elementu znajduje się poza viewportem
    if (rect.top >= 0 && rect.top <= 400) {
      pixelsOutside = rect.top; // Zliczamy tylko piksele od góry
      element.style.top = `${pixelsOutside / 4.05 - 100}%`;
      seProgress.style.width = `${100 - pixelsOutside / 4}%`;
    } else {
      if (rect.top < 400) {
        element.style.top = `-100%`;
        seProgress.style.width = "100%";
      } else {
        seProgress.style.width = "0%";
        element.style.top = `-0%`;
      }
    }
  }
  getPixelsOutsideViewportAdvan();
  document.addEventListener("scroll", getPixelsOutsideViewportAdvan);
});
